import { Modal } from "antd";

export default function PasswordGuidance({ visible, setVisible }) {
  return (
    <Modal
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
      closable={false}
      footer={false}
    >
      Your password must:
      <ul>
        <li>contain at least 8 characters</li>
        <li>contain at least one upper case letter</li>
        <li>contain at least one number</li>
        <li>be hard to guess</li>
      </ul>
      <strong>How do I make my password hard to guess?</strong>
      <p>
        Your password can be memorable, but it should be difficult to guess. The
        longer the better, we suggest having a password that is a mix of random
        words than you can still remember.
      </p>
      <p>
        A good way to create a strong and memorable password is to use three
        random words. Be creative and use words memorable to you, so that people
        cannot guess your password.
      </p>
      You should exclude:
      <ul>
        <li>
          Information that can be personally related to you (exclude any
          personal information that is known by others or can be found online)
        </li>
        <li>
          Easily guessable passwords that include common words (e.g.
          Password1234)
        </li>
      </ul>
      <strong>How should I store my password?</strong>
      <p>
        You should not write password down anywhere that can be accessed by
        someone else (either physically or on your computer). We recommend using
        a trusted password manager so that you don’t have to remember all your
        passwords.
      </p>
      <p>
        If you do use a password manager, we endorse{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.ncsc.gov.uk/collection/top-tips-for-staying-secure-online/password-managers"
        >
          guidance
        </a>{" "}
        set out by the National Cyber Security Centre (NCSC) who recommend that
        these managers are protected by:
      </p>
      <ul>
        <li>Setting up two-factor authorisation on your password manager</li>
        <li>Installing updates to your password manager once available.</li>
      </ul>
    </Modal>
  );
}
